import React from 'react'

const Refund = () => {
  return (
    <div>
     <div className="container py-lg-5 py-md-4 py-3">
  <div className="row">
    <h1 className='fw-bold'>Refund Policy</h1>
    <h6>Effective Date: Aug, 01, 2025</h6>
    <p>
      At TechTorch Solutions, we aim to provide clarity and fairness in our dealings. 
      This Refund Policy explains the circumstances under which payments made through our website 
      or payment gateway may be eligible for a refund.
    </p>

    <h4 className='fw-bold mt-lg-4 mt-3'>1. Eligibility for Refunds</h4>
    <ul className="list-unstyled">
      <li>Refunds may be considered in the following cases:</li>
      <li>Accidental or duplicate payments due to technical errors.</li>
      <li>Payment was deducted but the service was not delivered due to system failure.</li>
      <li>Any other genuine cases where the company determines a refund is justified.</li>
    </ul>

    <h4 className='fw-bold mt-lg-4 mt-3'>2. Non-Refundable Payments</h4>
    <ul className="list-unstyled">
      <li>Certain payments are strictly non-refundable, including but not limited to:</li>
      <li>Consultation fees, subscription charges, or partially delivered services.</li>
      <li>Custom or personalized services.</li>
    </ul>

    <h4 className='fw-bold mt-lg-4 mt-3'>3. Refund Process</h4>
    <ul className="list-unstyled">
      <li>If your refund request is approved, the amount will be processed back to the original payment method.</li>
      <li>Refunds will typically be credited within <span className='fw-bold'>7–10 business days</span>, depending on your bank or payment provider.</li>
      <li>Transaction charges, payment gateway fees, or administrative costs may be deducted from the refund amount.</li>
    </ul>

    <h4 className='fw-bold mt-lg-4 mt-3'>4. How to Request a Refund</h4>
    <ul className="list-unstyled">
      <li>To request a refund, please contact us with your transaction details at:</li>
      <li><span className='fw-bold'>Email: </span>contact@techtorch.solutions</li>
    </ul>

    <h4 className='fw-bold mt-lg-4 mt-3'>5. Changes to This Policy</h4>
    <p>
      TechTorch Solutions reserves the right to modify or update this Refund Policy at any time without prior notice. 
      Updates will be posted on this page, and we recommend reviewing it regularly.
    </p>
  </div>
</div>
 
    </div>
  )
}

export default Refund
